
import cookies from 'js-cookie'
import { defineComponent, getCurrentInstance, onMounted, ref, onUnmounted, computed, watch, onActivated } from 'vue';
import { formatUrls, getQuery, getUrlKwaiId, commonPvParams, getFullPath, getTargetUrlFromWebOrDesktop, checkSeoReferrer } from '@/common/utils'
import VideoAction from '@/components/video-swiper/components/video-action.vue';
import VideoInfo from '@/components/video-swiper/components/video-info.vue';
import VideoSwiper from '@/components/video-swiper/index.vue';
import NewOpenKwaiNotice from '@/components/new-open-kwai-notice/index.vue'
import { sendLog, immediateSendLog, getKwaiLog, radarLog } from '@/common/radar';
import { useLogin } from '@/hooks/useLogin';
import { autoLaunchAppWarp } from '@/common/call-app'
import { getTitle, getMetaInfo, header } from '@/common/seo'
import { setCommonParamsCookiesInServer } from '@/common/common-params'
import device from '@/common/device-info'

export default defineComponent<any>({
  components: {
    VideoAction,
    VideoInfo,
    NewOpenKwaiNotice,
    VideoSwiper,
  },
  // layout: 'noFooterLayout',
  setup() {
    const fmp_time = Date.now();
    const isIos = ref(false)
    const beginTime = ref(0) // 统计页面时长
    const { proxy } = getCurrentInstance() as { proxy: Record<string, any> };
    const { share_device_id, shareBucket, pwa_source } = proxy.$route.query
    // 登录 hooks
    const {
      showLoginPopup,
      isLoginStatus,
      handleLoginPopupClose,
      changeLoginStatus,
      handleLoginPopupOpenkwai,
      needCheckLogin
    } = useLogin();

    const isNoVideo = ref(false) // 没有查询到对应video
    const videoList = ref([])
    const photoItem = computed<Record<string, any>>(() => {
      return videoList.value[0] || null
    }) // 视频详情资源

    // 视频操作相关属性 hooks 逻辑
    const muted = ref(true)
    const showPlayBtn = ref(false) // 暂停键
    let videoElement = null as null | HTMLVideoElement

    const getVideoEle = (idStr?: string) => {
      return document.querySelector(idStr || 'video') as HTMLVideoElement;
    };

    const setVideoPlay = () => {
      muted.value = false
      videoElement = getVideoEle();
      const playPromise = videoElement?.play();
      if (typeof playPromise !== 'undefined') {
        playPromise
          .then(() => {
            // 记录play 到playing 的时间
            // sendPlayToPlayingTimeLog({ index: slideIndex.value })
            // 记录播放时间
            // proxy.$bus.emit('isLoad', false);
            showPlayBtn.value = false;
            // showPoster.value = false;
            // loading.value = false;
          })
          .catch(() => {
            // showPoster.value = true;
          });
      } else {
        // showPoster.value = false;
        // loading.value = false;
        // proxy.$bus.emit('isLoad', false);
      }
    };

    const onClickVideo = () => {
      if (!videoElement) {
        videoElement = getVideoEle();
      }
      if (videoElement?.paused) {
        showPlayBtn.value = false;
        setVideoPlay();
      } else {
        videoElement?.pause();
        showPlayBtn.value = true;
        // loading.value = false;
      }
    };
    // 视频操作相关属性 hooks end

    // 双击 hooks 逻辑
    const videoClickCount = ref(0) // 单击双击
    let videoClickTimer = null as any
    // 屏幕双击
    const checkDbClick = async (e: MouseEvent) => {
      videoClickCount.value++;
      if (videoClickCount.value === 1) {
        videoClickTimer = setTimeout(function () {
          videoClickCount.value = 0;
          onClickVideo()
        }, 300); // 设置一个时间间隔，单位为毫秒
      } else if (videoClickCount.value === 2) {
        clearTimeout(videoClickTimer);
        videoClickCount.value = 0;
        renderLiked(e)
        showNewOpenKwaiNotice.value = true
      }
    }
    // 在点击位置渲染红心
    const renderLiked = (event: MouseEvent) => {
      const heartWrap = document.createElement('div');
      const heartIcon = document.createElement('div');
      heartIcon.className = 'heart-icon'
      heartIcon.style.transform = `rotate(${Math.floor(Math.random() * 61) - 30}deg)`
      heartWrap.className = 'heart-dbclick-warp';
      heartWrap.style.top = event.clientY + 'px';
      heartWrap.style.left = event.clientX + 'px';
      heartWrap.appendChild(heartIcon);
      document.body.appendChild(heartWrap);
      setTimeout(function () {
        document.body.removeChild(heartWrap);
      }, 300);
    }
    // 双击 hooks 逻辑结束

    const handleVideoPlaying = () => { }
    const handleLoadingChange = () => { }

    // 点赞关注
    const handleActionClick = ({ type }: { type: string }) => {
      sendLog({
        type: 'click',
        name: 'DETAIL_BUTTON',
        value: {
          photo_id: `${photoItem.value?.photo_id_str}`,
          author_id: `${photoItem.value?.user_id}`,
          button_type: type
        }
      })
      showNewOpenKwaiNotice.value = true
    }

    const handleInfoClick = async ({ type }: { type: string }) => {
      // 后续打开
      if ((type === 'name' || type === 'photo')) {
        const query = getQuery()
        let kwaiId = getUrlKwaiId()
        return proxy.$router.push({ path: `/${kwaiId}`, query: { ...query, page_source: 'video_detail' } });
      }

      if (type === 'follow') {
        sendLog({
          type: 'click',
          name: 'DETAIL_BUTTON',
          value: {
            photo_id: `${photoItem.value?.photo_id_str}`,
            author_id: `${photoItem.value?.user_id}`,
            button_type: type
          }
        })
      }
      showNewOpenKwaiNotice.value = true
      // }
    }
    // 点赞关注end

    // popup
    const showNewOpenKwaiNotice = ref(false)
    const handleNewOpenKwaiNoticeClose = (params: Record<string, string>) => {
      sendLog({
        type: 'click',
        name: 'DETAIL_POP',
        value: {
          photo_id: `${photoItem.value?.photo_id_str}`,
          author_id: `${photoItem.value?.user_id}`,
          button_type: 'wait',
          pop_type: 'download_pop'
        }
      })
      showNewOpenKwaiNotice.value = false
    }

    const handleNewOpenKwaiNotice = (params: Record<string, string>) => {
      proxy.$bus.emit('launchApp', { callAppPath: `work/${proxy.$route.params.photoId}` })
      sendLog({
        type: 'click',
        name: 'DETAIL_POP',
        value: {
          photo_id: `${photoItem.value?.photo_id_str}`,
          author_id: `${photoItem.value?.user_id}`,
          button_type: 'download',
          pop_type: 'download_pop'
        }
      })
      setTimeout(() => {
        showNewOpenKwaiNotice.value = false
      }, 0)
    }
    watch(() => showNewOpenKwaiNotice.value, (newValue) => {
      if (newValue) {
        sendLog({
          type: 'show',
          name: 'DETAIL_POP',
          value: {
            photo_id: `${photoItem.value?.photo_id_str}`,
            author_id: `${photoItem.value?.user_id}`,
            button_type: 'download_pop'
          }
        })
      }
    })

    const onError = () => {
      radarLog({
        name: 'PWA_VIDEO_ERROR',
        event_type: 'click',
        category: 'KWAI_SHARE',
        message: `error url: ${photoItem.value?.main_mv_urls[0]?.url}`,
        src: window.location.pathname,
      });
    };

    const backClickHandle = () => {
      // if (checkSeoReferrer()) {
      //   const query = getQuery()
      //   proxy.$router.push({ path: '/foryou', query: { ...query, page_source: 'detail' } });
      // } else {
      window.history.back()
      // }
    }

    const getVideoList = async (photoId?: string) => {
      let res = await proxy.$axios.$$post('overseaAPI::/rest/o/w/pwa/photo/get', { photoId })

      const { result, feeds } = res || {};

      return {
        result,
        feeds
      }
    }

    const sendPv = () => {
      const params = commonPvParams({ defaultPageSource: 'detail' })
      // 获取启动config
      const country = proxy.$store.state.startup.countryInfo
      const user_id = cookies.get('user_id')
      immediateSendLog({
        type: 'pv',
        name: 'PWA_DETAIL_PAGE',
        value: {
          country,
          user_id,
          ...params
        }
      })
    }

    const consume_duration = () => {
      const consume_duration = new Date().getTime() - beginTime.value
      const webLogger = getKwaiLog();
      immediateSendLog({
        type: 'click',
        name: 'CONSUME_DURATION',
        value: {
          type: 'STAY_LENGTH_STAT_EVENT',
          duration_time: consume_duration,
          photo_id: `${photoItem.value?.photo_id_str}`,
          author_id: `${photoItem.value?.user_id}`
        }
      })
      // 停留时长
      webLogger.sendImmediately('PV', {
        type: 'leave',
        beginTime,
      });
      // 每次触发离开事件 都重新计时
      beginTime.value = new Date().getTime()
    }

    // 获取更多
    const handleLoadMore = async (photoId?: string) => {
      const { feeds } = await getFeedVideoList(photoId);
      const videoPlayQueue: any = videoList.value;
      videoPlayQueue.push(...feeds);
      videoList.value = videoPlayQueue;
    };

    const handleRefresh = async () => {
      const { feeds } = await getFeedVideoList();
      videoList.value = feeds;
    };

    const getFeedVideoList = async (photoId?: string) => {
      let res = await proxy.$axios.$$post('overseaAPI::/rest/o/w/share/pwa/feed', {
        photoId,
        shareDeviceId: share_device_id,
        shareBucket,
        fromPage: 'PWA_DETAIL_FEED'
      })

      const { result, feeds, index, llsid } = res || {};

      return {
        result,
        index,
        llsid,
        feeds
      }
    }

    const handleVisibilityChange = () => {
      // 点击暂停后不触发visibie事件
      if (!videoElement) {
        videoElement = getVideoEle();
      }
      // 切换出去时发送最后一个视频的时间 切换回来重新计时
      if (document.visibilityState === 'visible' && !showLoginPopup.value && !showNewOpenKwaiNotice.value) {
        setVideoPlay();
      }
    };

    onMounted(async () => {
      beginTime.value = new Date().getTime();
      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('beforeunload', consume_duration);

      const webLogger = getKwaiLog();
      try {
        webLogger?.plugins?.radar?.fmp(fmp_time);
      } catch (error) {
        console.error(error);
      }

      sendPv()

      setTimeout(() => {
        autoLaunchAppWarp(`ikwai://work/${proxy.$route?.params?.photoId}?target_url=${getTargetUrlFromWebOrDesktop()}`);
      }, 500);
      // 过了node
      if (proxy?.photoList?.length) {
        videoList.value = proxy.photoList
        // todo 有个问题 如果pwa source = share 是从上一个页面带过来的 需要展示什么
      } else if (pwa_source === 'share') {
        isIos.value = device().isIOS
        handleLoadMore(proxy.$route.params.photoId)
      } else {
        // 没过node，或者node也没调用到
        proxy.$bus.emit('isLoad', true)
        const { result, feeds } = await getVideoList(proxy.$route.params.photoId)
        proxy.$bus.emit('isLoad', false)
        if (result === 1) {
          videoList.value = feeds
          if (feeds.length === 0) {
            isNoVideo.value = true
          }
        }
      }
    })

    onActivated(() => {
      handleVisibilityChange()
    })

    onUnmounted(() => {
      window.removeEventListener('beforeunload', consume_duration);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    })




    return {
      proxy,
      showPlayBtn,
      photoItem,
      showNewOpenKwaiNotice,
      showLoginPopup,
      isLoginStatus,
      isNoVideo,
      videoList,
      isIos,
      muted,
      handleLoginPopupClose,
      changeLoginStatus,
      handleLoginPopupOpenkwai,
      needCheckLogin,
      checkDbClick,
      handleVideoPlaying,
      handleLoadingChange,
      handleActionClick,
      formatUrls,
      handleInfoClick,
      handleNewOpenKwaiNoticeClose,
      handleNewOpenKwaiNotice,
      backClickHandle,
      handleLoadMore,
      handleRefresh,
      onError
    };
  },
  async asyncData(ctx) {
    let photoList = []
    let seoData = []
    let metaInfoData = []
    let title = 'kwai';
    let showFeed = false
    const { query } = ctx
    // const fullPath = getFullPath(ctx);
    if (process.server) {

      setCommonParamsCookiesInServer({ bucket: ctx.store.state.startup.bucket, host: ctx.req.headers.host, ctx, countryInfo: ctx.store.state.startup.countryInfo })

      try {
        const { photoId, share_device_id, shareBucket } = ctx.route?.query
        const realPhotoId = ctx?.route?.params?.photoId || photoId
        showFeed = query.pwa_source === 'share'
        // 获取google ldjson 标签
        let seoPromise = ctx.$axios.$$get(`overseaAPI::/rest/o/w/seo/ldJson/getByType?type=PHOTO&id=${realPhotoId}`)
        // let seoPromise = getLdJson({ ctx, params: { type: 'PHOTO', id: realPhotoId } })
        let metaInfoPromise = getMetaInfo({ ctx, params: { type: 'PHOTO', id: realPhotoId, locale: ctx.req.headers['accept-language'] } })
        let titlePromise = getTitle({ ctx, params: { type: 'PHOTO', id: realPhotoId } })

        let photoPromise
        if (!showFeed) {
          photoPromise = ctx.$axios.$$post('overseaAPI::/rest/o/w/pwa/photo/get', { photoId: realPhotoId })
        } else {
          photoPromise = ctx.$axios.$$post('overseaAPI::/rest/o/w/share/pwa/feed', {
            photoId: realPhotoId,
            shareDeviceId: share_device_id,
            shareBucket,
            fromPage: 'PWA_DETAIL_FEED'
          })
        }
        let [photoRes, seoRes, metaInfoRes, titleRes] = await Promise.all([photoPromise, seoPromise, metaInfoPromise, titlePromise])

        if (photoRes.result === 1) {
          photoList = photoRes.feeds
        }

        if (seoRes.status === 200) {
          seoData = seoRes.data
        }

        if (metaInfoRes.status === 200) {
          metaInfoData = metaInfoRes.data
        }

        if (titleRes.status === 200) {
          title = titleRes.data
        }

      } catch (error) {
        console.log(error)
      }

    }


    return {
      photoList,
      showFeed,
      seoData,
      metaInfoData,
      title
    }
  },

  head() {
    const head = header(this)
    return {
      ...head
    }
  },
});

